<template>
  <a-modal :visible="visible" title="违规订单" :width="1000" :footer="false" :maskClosable="false" @cancel="handleCancel">
    <a-card :bordered="false">
      <!-- <div :style="{ position: 'absolute', top: '-15px', right: '25px' }"
        v-if="selectedRows.length > 0">
        <a-button type="primary" :style="{ marginRight: '10px'}"
          @click="deductionRebate">扣除返利</a-button>
        <a-button type="danger" style="background-color: #ff4d4f; color: #fff;"
          @click="uploadBlacklist">上传用户到黑名单</a-button>
      </div> -->
      <a-table :scroll="{ x: 1300 }" :columns="columns" :dataSource="data" rowKey="tb_trade_id"
        @change="tableChange" :pagination="pagein" ref="table" :loading="loading"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
        <!-- 推广位 -->
        <span slot="pid" slot-scope="text, record">
          {{ record.sub_info ? record.sub_info.pid: '无' }}
        </span>
        <!-- 商品名称 -->
        <span slot="goodsname" slot-scope="text, record">
          {{ record.tb_order_info.item_title }}
        </span>
        <!-- 机器人id -->
        <span slot="subId" slot-scope="text, record">
          {{ record.sub_info ? record.sub_info.sub_id : '无' }}
        </span>
        <!-- 机器人名称 -->
        <span slot="nickName" slot-scope="text, record">
          {{ record.sub_info ? record.sub_info.nickname : '无' }}
        </span>
        <!-- 会员 -->
        <span slot="user" slot-scope="text, record">
          {{ record.tb_order_info.wxid }}
        </span>
        <!-- 会员名称 -->
        <span slot="userName" slot-scope="text, record">
          {{ record.tb_order_info.user_info.nickname }}
        </span>
        <!-- 返利 -->
        <span slot="fl_balance" slot-scope="text, record">
          <a-tag color="blue">用户奖励： {{ record.tb_order_info.fl_user }}</a-tag>
          <a-tag color="orange">上级奖励：{{ record.tb_order_info.fl_agent }}</a-tag>
          <a-tag color="cyan">上上级奖励： {{ record.tb_order_info.fl_second }}</a-tag>
        </span>
        <!-- 操作 -->
        <span slot="action" slot-scope="text, record">
          <template>
            <a>操作</a>
          </template>
        </span>
      </a-table>

      <send-msg-modal ref="sendMsgModal"></send-msg-modal>
    </a-card>
  </a-modal>
</template>

<script>
import moment from 'moment'
import SendMsgModal from './SendMsgModal'

import CompanyApi from '@/api/company'
import FansApi from '@/api/fans'

const columns = [
  {
    title: '订单号',
    align: 'center',
    dataIndex: 'tb_trade_id'
  },
  {
    title: '商品名称',
    align: 'center',
    scopedSlots: { customRender: 'goodsname' }
  },
  {
    title: '推广位',
    align: 'center',
    scopedSlots: { customRender: 'pid' }
  },
  {
    title: '违规原因',
    align: 'center',
    dataIndex: 'violation_type',
  },
  {
    title: '会员wxid',
    align: 'center',
    scopedSlots: { customRender: 'user' }
  },
  {
    title: '会员名称',
    align: 'center',
    scopedSlots: { customRender: 'userName' }
  },
  {
    title: '返利',
    align: 'center',
    scopedSlots: { customRender: 'fl_balance' }
  },
  {
    title: '机器人id',
    align: 'center',
    scopedSlots: { customRender: 'subId' }
  },
  {
    title: '机器人名称',
    align: 'center',
    scopedSlots: { customRender: 'nickName' }
  },
  {
    title: '订单创建时间',
    align: 'center',
    dataIndex: 'tk_trade_create_time'
  },
  // {
  //   title: '操作',
  //   dataIndex: 'action',
  //   fixed: 'right',
  //   align: 'center',
  //   scopedSlots: { customRender: 'action' }
  // }
]
export default {
  components: {
    SendMsgModal
  },
  data() {
    this.columns = columns
    return {
      labelCol: {
        xs: { span: 24 }, sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 }, sm: { span: 13 }
      },
      visible: false,
      data: [], // table的dataSource值
      loading: false, // 表格数据加载中
      selectedRowKeys: [],
      selectedRows: [],
      pagein: {
        current: 1, // 当前页
        pageSize: 10, // 每页条数
        total: 0, // 数据总数
        showSizeChanger: true, // 是否可改变每页条数
        showQuickJumper: true, // 是否可快速跳转至某页
      },
      access_token: '',
    }
  },

  methods: {
    show(item) {
      this.access_token = item.access_token
      this.pagein.current = 1
      this.pagein.pageSize = 10
      this.irregularOrders()
      this.visible = true
    },

    handleCancel() {
      this.visible = false
      this.data = []
    },

    // 违规订单列表
    irregularOrders() {
      this.loading = true
      const data = {
        pageNo: this.pagein.current,
        pageSize: this.pagein.pageSize,
        accessToken: this.access_token
        // accessToken: '70002100b19544995f68987eed8e86b1da622a11aef83d6c07a285a79a0a6902a13bd141655271192'
      }
      CompanyApi.getIrregularOrders(data).then(res => {
        if (res.code === 1) {
          // console.log('res=', res)
          this.data = res.data.list
//           this.data = [
//   {
//     "punish_status": "0",
//     "settle_month": "202305",
//     "tb_trade_id": "3370238713999220564",
//     "tk_adzone_id": "114620150497",
//     "tk_pub_id": "2494480130",
//     "tk_site_id": "2607100136",
//     "tk_trade_create_time": "2023-05-30 20:19:50",
//     "violation_type": "订单虚假交易",
//     "sub_info": {
//       "pid": "2607100136_114620150497",
//       "sub_id": 15660,
//       "sub_remark": null,
//       "nickname": "a查券员6号置顶我哟陶宝查优慧券"
//     },
//     "tb_order_info": {
//       "id": 106564,
//       "sub_id": 15660,
//       "wxid": "wxid_w5y2vtiu4s6622",
//       "userid": 4765,
//       "fl_group": "0.01",
//       "fl_agent": "0.03",
//       "fl_second": "0.01",
//       "fl_user": "0.33",
//       "fl_Integral": null,
//       "flstatus": 1,
//       "luckdrawTAG": 0,
//       "luckdraw_time": "2023-05-31 15:58:00",
//       "relation_id": "",
//       "adzone_id": "114620150497",
//       "adzone_name": "6",
//       "alimama_rate": "10.00",
//       "alimama_share_fee": "0.04",
//       "alipay_total_price": "13.90",
//       "app_key": "24665425",
//       "click_time": "2023-05-29 19:45:23",
//       "deposit_price": "0.00",
//       "flow_source": "--",
//       "income_rate": "3.00",
//       "item_category_name": "彩妆/香水/美妆工具",
//       "pay_price": "13.90",
//       "item_id": "XrtpUgt0ZqtBtg-p6q9AoRfRAAkK7wdtj6",
//       "item_img": "//img.alicdn.com/tfscom/i1/3937219703/O1CN01ohJDGs2LY1rwvD5bt_!!3937219703.jpg",
//       "item_link": "//uland.taobao.com/item/edetail?id=XrtpUgt0ZqtBtg-p6q9AoRfRAAkK7wdtj6",
//       "item_num": 1,
//       "item_price": "20.85",
//       "item_title": "三色遮瑕膏盘官方旗舰遮盖眼袋脸部黑眼圈痘印斑点正品店",
//       "pub_id": "2494480130",
//       "pub_share_fee": "0.42",
//       "pub_share_pre_fee": "0.42",
//       "pub_share_rate": "100.00",
//       "refund_tag": 0,
//       "seller_nick": "天天特卖工厂店",
//       "seller_shop_title": "天天特卖工厂店",
//       "site_id": "2607100136",
//       "site_name": "爱分享(手机客户端专享)_2494480130",
//       "subsidy_fee": "0.00",
//       "subsidy_rate": "0.00",
//       "subsidy_type": "--",
//       "tb_deposit_time": "--",
//       "tb_paid_time": "2023-05-30 20:19:47",
//       "terminal_type": "无线",
//       "tk_commission_fee_for_media_platform": "0.00",
//       "tk_commission_pre_fee_for_media_platform": "0.00",
//       "tk_commission_rate_for_media_platform": "0.00",
//       "tk_create_time": "2023-05-30 20:19:50",
//       "tk_earning_time": "2023-05-31 15:55:16",
//       "tk_deposit_time": "--",
//       "tk_order_role": 2,
//       "tk_paid_time": "2023-05-30 20:20:02",
//       "tk_status": 3,
//       "tk_total_rate": "3.00",
//       "total_commission_fee": "0.42",
//       "total_commission_rate": "3.00",
//       "trade_id": "3370238713999220564",
//       "trade_parent_id": "3370238713998220564",
//       "tb_user_id": "",
//       "op_status": 0,
//       "binding_miss_remark": "",
//       "extra_type": 0,
//       "create_time": "2023-05-30 20:21:11",
//       "update_time": "2023-06-07 15:30:52",
//       "luckdrawTIME": null,
//       "user_info": {
//         "uid": 4765,
//         "sub_id": 15660,
//         "wxid": "wxid_w5y2vtiu4s6622",
//         "nickname": "壵壵熊",
//         "username": "bbifjjddr",
//         "usertype": 15,
//         "integral": 0,
//         "qdcount": 0,
//         "sign_amount": "0.00",
//         "qdlastdt": "",
//         "mmpid": "",
//         "pidname": "",
//         "trjid": "4281",
//         "groupid": "0",
//         "groupwxid": "",
//         "groupname": "",
//         "balance": "0.60",
//         "alipayrealname": "",
//         "alipaynum": "",
//         "regtime": "2023-04-13 14:16:53",
//         "order_sixbit": "220564",
//         "jdpid": "",
//         "pddpid": "",
//         "pdd_order_lastbit": "",
//         "order_num": 2473,
//         "smkey": 0,
//         "del": "0",
//         "order_date": "2023-06-28",
//         "jinjie1": "1",
//         "jinjie2": "1",
//         "jinjie3": "0",
//         "first_award": "1",
//         "remark": "",
//         "region": "",
//         "Evaluate_num": 0,
//         "avatar": "http://wx.qlogo.cn/mmhead/ver_1/icATFjlbKx1ZeQajHwz391C25JycORqdjUGicjZyvVrQ4bnchGWFPvkSQqugM3HY0cCpRTPAiaAVsgicQSBcmsPFrz4CUBVRFUNq0L1953y5X1o/0",
//         "openid": "",
//         "province": "",
//         "mark": "A2023-06-28单2473推13提688.06D4765壵壵熊",
//         "customer_remark": "",
//         "sex": 0,
//         "address": "",
//         "tag": null,
//         "invite_code": null,
//         "withdraw_amount": "688.06",
//         "finished_amount": "620.40",
//         "pay_amount": "28.84",
//         "useless_amount": null,
//         "finished_orders_number": 2319,
//         "pay_orders_number": 154,
//         "useless_orders_number": 0,
//         "sub_withdraw": "79.93",
//         "update_time": "2023-06-28 16:07:35",
//         "tb_user_id": ""
//       }
//     }
//   },
//   {
//     "punish_status": "0",
//     "settle_month": "202305",
//     "tb_trade_id": "3370238714000220564",
//     "tk_adzone_id": "114620150497",
//     "tk_pub_id": "2494480130",
//     "tk_site_id": "2607100136",
//     "tk_trade_create_time": "2023-05-30 20:19:50",
//     "violation_type": "订单虚假交易",
//     "sub_info": {
//       "pid": "2607100136_114620150497",
//       "sub_id": 15660,
//       "sub_remark": null,
//       "nickname": "a查券员6号置顶我哟陶宝查优慧券"
//     },
//     "tb_order_info": {
//       "id": 106563,
//       "sub_id": 15660,
//       "wxid": "wxid_w5y2vtiu4s6622",
//       "userid": 4765,
//       "fl_group": "0.01",
//       "fl_agent": "0.03",
//       "fl_second": "0.01",
//       "fl_user": "0.31",
//       "fl_Integral": null,
//       "flstatus": 1,
//       "luckdrawTAG": 0,
//       "luckdraw_time": "2023-05-31 15:57:49",
//       "relation_id": "",
//       "adzone_id": "114620150497",
//       "adzone_name": "6",
//       "alimama_rate": "10.00",
//       "alimama_share_fee": "0.04",
//       "alipay_total_price": "12.90",
//       "app_key": "24665425",
//       "click_time": "2023-05-29 19:45:23",
//       "deposit_price": "0.00",
//       "flow_source": "--",
//       "income_rate": "3.00",
//       "item_category_name": "美容护肤/美体/精油",
//       "pay_price": "12.90",
//       "item_id": "K5twUvtOkwTJtW-P8yrmq4uKyV9GG0KcGO",
//       "item_img": "//img.alicdn.com/tfscom/i3/3937219703/O1CN01nwFDjj2LY1rsQR8LZ_!!3937219703.jpg",
//       "item_link": "//uland.taobao.com/item/edetail?id=K5twUvtOkwTJtW-P8yrmq4uKyV9GG0KcGO",
//       "item_num": 1,
//       "item_price": "19.35",
//       "item_title": "黄芪霜祛黄老牌国货面霜去改善黄皮肤美氏变嫩白护肤滋润保湿补水",
//       "pub_id": "2494480130",
//       "pub_share_fee": "0.39",
//       "pub_share_pre_fee": "0.39",
//       "pub_share_rate": "100.00",
//       "refund_tag": 0,
//       "seller_nick": "天天特卖工厂店",
//       "seller_shop_title": "天天特卖工厂店",
//       "site_id": "2607100136",
//       "site_name": "爱分享(手机客户端专享)_2494480130",
//       "subsidy_fee": "0.00",
//       "subsidy_rate": "0.00",
//       "subsidy_type": "--",
//       "tb_deposit_time": "--",
//       "tb_paid_time": "2023-05-30 20:19:47",
//       "terminal_type": "无线",
//       "tk_commission_fee_for_media_platform": "0.00",
//       "tk_commission_pre_fee_for_media_platform": "0.00",
//       "tk_commission_rate_for_media_platform": "0.00",
//       "tk_create_time": "2023-05-30 20:19:50",
//       "tk_earning_time": "2023-05-31 15:55:17",
//       "tk_deposit_time": "--",
//       "tk_order_role": 2,
//       "tk_paid_time": "2023-05-30 20:20:02",
//       "tk_status": 3,
//       "tk_total_rate": "3.00",
//       "total_commission_fee": "0.39",
//       "total_commission_rate": "3.00",
//       "trade_id": "3370238714000220564",
//       "trade_parent_id": "3370238713998220564",
//       "tb_user_id": "",
//       "op_status": 0,
//       "binding_miss_remark": "",
//       "extra_type": 0,
//       "create_time": "2023-05-30 20:21:11",
//       "update_time": "2023-06-07 15:30:58",
//       "luckdrawTIME": null,
//       "user_info": {
//         "uid": 4765,
//         "sub_id": 15660,
//         "wxid": "wxid_w5y2vtiu4s6622",
//         "nickname": "壵壵熊",
//         "username": "bbifjjddr",
//         "usertype": 15,
//         "integral": 0,
//         "qdcount": 0,
//         "sign_amount": "0.00",
//         "qdlastdt": "",
//         "mmpid": "",
//         "pidname": "",
//         "trjid": "4281",
//         "groupid": "0",
//         "groupwxid": "",
//         "groupname": "",
//         "balance": "0.60",
//         "alipayrealname": "",
//         "alipaynum": "",
//         "regtime": "2023-04-13 14:16:53",
//         "order_sixbit": "220564",
//         "jdpid": "",
//         "pddpid": "",
//         "pdd_order_lastbit": "",
//         "order_num": 2473,
//         "smkey": 0,
//         "del": "0",
//         "order_date": "2023-06-28",
//         "jinjie1": "1",
//         "jinjie2": "1",
//         "jinjie3": "0",
//         "first_award": "1",
//         "remark": "",
//         "region": "",
//         "Evaluate_num": 0,
//         "avatar": "http://wx.qlogo.cn/mmhead/ver_1/icATFjlbKx1ZeQajHwz391C25JycORqdjUGicjZyvVrQ4bnchGWFPvkSQqugM3HY0cCpRTPAiaAVsgicQSBcmsPFrz4CUBVRFUNq0L1953y5X1o/0",
//         "openid": "",
//         "province": "",
//         "mark": "A2023-06-28单2473推13提688.06D4765壵壵熊",
//         "customer_remark": "",
//         "sex": 0,
//         "address": "",
//         "tag": null,
//         "invite_code": null,
//         "withdraw_amount": "688.06",
//         "finished_amount": "620.40",
//         "pay_amount": "28.84",
//         "useless_amount": null,
//         "finished_orders_number": 2319,
//         "pay_orders_number": 154,
//         "useless_orders_number": 0,
//         "sub_withdraw": "79.93",
//         "update_time": "2023-06-28 16:07:35",
//         "tb_user_id": ""
//       }
//     }
//   },
//   {
//     "punish_status": "0",
//     "settle_month": "202305",
//     "tb_trade_id": "3370243429001220564",
//     "tk_adzone_id": "114620150497",
//     "tk_pub_id": "2494480130",
//     "tk_site_id": "2607100136",
//     "tk_trade_create_time": "2023-05-30 20:19:50",
//     "violation_type": "订单虚假交易",
//     "sub_info": {
//       "pid": "2607100136_114620150497",
//       "sub_id": 15660,
//       "sub_remark": null,
//       "nickname": "a查券员6号置顶我哟陶宝查优慧券"
//     },
//     "tb_order_info": {
//       "id": 106562,
//       "sub_id": 15660,
//       "wxid": "wxid_w5y2vtiu4s6622",
//       "userid": 4765,
//       "fl_group": "0.01",
//       "fl_agent": "0.04",
//       "fl_second": "0.01",
//       "fl_user": "0.35",
//       "fl_Integral": null,
//       "flstatus": 1,
//       "luckdrawTAG": 0,
//       "luckdraw_time": "2023-05-31 15:57:38",
//       "relation_id": "",
//       "adzone_id": "114620150497",
//       "adzone_name": "6",
//       "alimama_rate": "10.00",
//       "alimama_share_fee": "0.04",
//       "alipay_total_price": "14.90",
//       "app_key": "24665425",
//       "click_time": "2023-05-29 19:45:23",
//       "deposit_price": "0.00",
//       "flow_source": "--",
//       "income_rate": "3.00",
//       "item_category_name": "美容护肤/美体/精油",
//       "pay_price": "14.90",
//       "item_id": "qYtrU8tDeYSWt0-dn2bKJ5TnMMJjoDPIP",
//       "item_img": "//img.alicdn.com/tfscom/i1/2215727205460/O1CN01CSDZUL1qCjMM34wUl_!!2215727205460-0-scmitem176000.jpg",
//       "item_link": "//uland.taobao.com/item/edetail?id=qYtrU8tDeYSWt0-dn2bKJ5TnMMJjoDPIP",
//       "item_num": 1,
//       "item_price": "22.35",
//       "item_title": "柳丝黑茶卸妆油膏水木女眼唇脸三合一温和深层清洁养肤官方正品",
//       "pub_id": "2494480130",
//       "pub_share_fee": "0.45",
//       "pub_share_pre_fee": "0.45",
//       "pub_share_rate": "100.00",
//       "refund_tag": 0,
//       "seller_nick": "天天特卖工厂店",
//       "seller_shop_title": "天天特卖工厂店",
//       "site_id": "2607100136",
//       "site_name": "爱分享(手机客户端专享)_2494480130",
//       "subsidy_fee": "0.00",
//       "subsidy_rate": "0.00",
//       "subsidy_type": "--",
//       "tb_deposit_time": "--",
//       "tb_paid_time": "2023-05-30 20:19:47",
//       "terminal_type": "无线",
//       "tk_commission_fee_for_media_platform": "0.00",
//       "tk_commission_pre_fee_for_media_platform": "0.00",
//       "tk_commission_rate_for_media_platform": "0.00",
//       "tk_create_time": "2023-05-30 20:19:50",
//       "tk_earning_time": "2023-05-31 15:55:16",
//       "tk_deposit_time": "--",
//       "tk_order_role": 2,
//       "tk_paid_time": "2023-05-30 20:20:02",
//       "tk_status": 3,
//       "tk_total_rate": "3.00",
//       "total_commission_fee": "0.45",
//       "total_commission_rate": "3.00",
//       "trade_id": "3370243429001220564",
//       "trade_parent_id": "3370238713998220564",
//       "tb_user_id": "",
//       "op_status": 0,
//       "binding_miss_remark": "",
//       "extra_type": 0,
//       "create_time": "2023-05-30 20:21:11",
//       "update_time": "2023-06-07 15:30:54",
//       "luckdrawTIME": null,
//       "user_info": {
//         "uid": 4765,
//         "sub_id": 15660,
//         "wxid": "wxid_w5y2vtiu4s6622",
//         "nickname": "壵壵熊",
//         "username": "bbifjjddr",
//         "usertype": 15,
//         "integral": 0,
//         "qdcount": 0,
//         "sign_amount": "0.00",
//         "qdlastdt": "",
//         "mmpid": "",
//         "pidname": "",
//         "trjid": "4281",
//         "groupid": "0",
//         "groupwxid": "",
//         "groupname": "",
//         "balance": "0.60",
//         "alipayrealname": "",
//         "alipaynum": "",
//         "regtime": "2023-04-13 14:16:53",
//         "order_sixbit": "220564",
//         "jdpid": "",
//         "pddpid": "",
//         "pdd_order_lastbit": "",
//         "order_num": 2473,
//         "smkey": 0,
//         "del": "0",
//         "order_date": "2023-06-28",
//         "jinjie1": "1",
//         "jinjie2": "1",
//         "jinjie3": "0",
//         "first_award": "1",
//         "remark": "",
//         "region": "",
//         "Evaluate_num": 0,
//         "avatar": "http://wx.qlogo.cn/mmhead/ver_1/icATFjlbKx1ZeQajHwz391C25JycORqdjUGicjZyvVrQ4bnchGWFPvkSQqugM3HY0cCpRTPAiaAVsgicQSBcmsPFrz4CUBVRFUNq0L1953y5X1o/0",
//         "openid": "",
//         "province": "",
//         "mark": "A2023-06-28单2473推13提688.06D4765壵壵熊",
//         "customer_remark": "",
//         "sex": 0,
//         "address": "",
//         "tag": null,
//         "invite_code": null,
//         "withdraw_amount": "688.06",
//         "finished_amount": "620.40",
//         "pay_amount": "28.84",
//         "useless_amount": null,
//         "finished_orders_number": 2319,
//         "pay_orders_number": 154,
//         "useless_orders_number": 0,
//         "sub_withdraw": "79.93",
//         "update_time": "2023-06-28 16:07:35",
//         "tb_user_id": ""
//       }
//     }
//   },
//   {
//     "punish_status": "0",
//     "settle_month": "202305",
//     "tb_trade_id": "3370522503586145164",
//     "tk_adzone_id": "114620150497",
//     "tk_pub_id": "2494480130",
//     "tk_site_id": "2607100136",
//     "tk_trade_create_time": "2023-05-30 20:07:26",
//     "violation_type": "订单虚假交易",
//     "sub_info": {
//       "pid": "2607100136_114620150497",
//       "sub_id": 15660,
//       "sub_remark": null,
//       "nickname": "a查券员6号置顶我哟陶宝查优慧券"
//     },
//     "tb_order_info": {
//       "id": 106549,
//       "sub_id": 15660,
//       "wxid": "wxid_w5y2vtiu4s6622",
//       "userid": 4765,
//       "fl_group": "0.01",
//       "fl_agent": "0.03",
//       "fl_second": "0.01",
//       "fl_user": "0.33",
//       "fl_Integral": null,
//       "flstatus": 1,
//       "luckdrawTAG": 0,
//       "luckdraw_time": "2023-05-31 15:41:08",
//       "relation_id": "",
//       "adzone_id": "114620150497",
//       "adzone_name": "6",
//       "alimama_rate": "10.00",
//       "alimama_share_fee": "0.04",
//       "alipay_total_price": "13.90",
//       "app_key": "24665425",
//       "click_time": "2023-05-29 19:27:41",
//       "deposit_price": "0.00",
//       "flow_source": "--",
//       "income_rate": "3.00",
//       "item_category_name": "彩妆/香水/美妆工具",
//       "pay_price": "13.90",
//       "item_id": "XrtpUgt0ZqtBtg-p6q9AoRfRAAkK7wdtj6",
//       "item_img": "//img.alicdn.com/tfscom/i1/3937219703/O1CN01ohJDGs2LY1rwvD5bt_!!3937219703.jpg",
//       "item_link": "//uland.taobao.com/item/edetail?id=XrtpUgt0ZqtBtg-p6q9AoRfRAAkK7wdtj6",
//       "item_num": 1,
//       "item_price": "20.85",
//       "item_title": "三色遮瑕膏盘官方旗舰遮盖眼袋脸部黑眼圈痘印斑点正品店",
//       "pub_id": "2494480130",
//       "pub_share_fee": "0.42",
//       "pub_share_pre_fee": "0.42",
//       "pub_share_rate": "100.00",
//       "refund_tag": 0,
//       "seller_nick": "天天特卖工厂店",
//       "seller_shop_title": "天天特卖工厂店",
//       "site_id": "2607100136",
//       "site_name": "爱分享(手机客户端专享)_2494480130",
//       "subsidy_fee": "0.00",
//       "subsidy_rate": "0.00",
//       "subsidy_type": "--",
//       "tb_deposit_time": "--",
//       "tb_paid_time": "2023-05-30 20:07:24",
//       "terminal_type": "无线",
//       "tk_commission_fee_for_media_platform": "0.00",
//       "tk_commission_pre_fee_for_media_platform": "0.00",
//       "tk_commission_rate_for_media_platform": "0.00",
//       "tk_create_time": "2023-05-30 20:07:26",
//       "tk_earning_time": "2023-05-31 15:39:43",
//       "tk_deposit_time": "--",
//       "tk_order_role": 2,
//       "tk_paid_time": "2023-05-30 20:07:39",
//       "tk_status": 3,
//       "tk_total_rate": "3.00",
//       "total_commission_fee": "0.42",
//       "total_commission_rate": "3.00",
//       "trade_id": "3370522503586145164",
//       "trade_parent_id": "3370522503585145164",
//       "tb_user_id": "",
//       "op_status": 0,
//       "binding_miss_remark": "尾号(145164)追单:用户WXID[qq174795826]，查券记录追单：2条，[wxid_9yyd5nf2rn7c22|wxid_w5y2vtiu4s6622|]",
//       "extra_type": 0,
//       "create_time": "2023-05-30 20:08:14",
//       "update_time": "2023-06-07 15:30:46",
//       "luckdrawTIME": null,
//       "user_info": {
//         "uid": 4765,
//         "sub_id": 15660,
//         "wxid": "wxid_w5y2vtiu4s6622",
//         "nickname": "壵壵熊",
//         "username": "bbifjjddr",
//         "usertype": 15,
//         "integral": 0,
//         "qdcount": 0,
//         "sign_amount": "0.00",
//         "qdlastdt": "",
//         "mmpid": "",
//         "pidname": "",
//         "trjid": "4281",
//         "groupid": "0",
//         "groupwxid": "",
//         "groupname": "",
//         "balance": "0.60",
//         "alipayrealname": "",
//         "alipaynum": "",
//         "regtime": "2023-04-13 14:16:53",
//         "order_sixbit": "220564",
//         "jdpid": "",
//         "pddpid": "",
//         "pdd_order_lastbit": "",
//         "order_num": 2473,
//         "smkey": 0,
//         "del": "0",
//         "order_date": "2023-06-28",
//         "jinjie1": "1",
//         "jinjie2": "1",
//         "jinjie3": "0",
//         "first_award": "1",
//         "remark": "",
//         "region": "",
//         "Evaluate_num": 0,
//         "avatar": "http://wx.qlogo.cn/mmhead/ver_1/icATFjlbKx1ZeQajHwz391C25JycORqdjUGicjZyvVrQ4bnchGWFPvkSQqugM3HY0cCpRTPAiaAVsgicQSBcmsPFrz4CUBVRFUNq0L1953y5X1o/0",
//         "openid": "",
//         "province": "",
//         "mark": "A2023-06-28单2473推13提688.06D4765壵壵熊",
//         "customer_remark": "",
//         "sex": 0,
//         "address": "",
//         "tag": null,
//         "invite_code": null,
//         "withdraw_amount": "688.06",
//         "finished_amount": "620.40",
//         "pay_amount": "28.84",
//         "useless_amount": null,
//         "finished_orders_number": 2319,
//         "pay_orders_number": 154,
//         "useless_orders_number": 0,
//         "sub_withdraw": "79.93",
//         "update_time": "2023-06-28 16:07:35",
//         "tb_user_id": ""
//       }
//     }
//   },
//   {
//     "punish_status": "0",
//     "settle_month": "202305",
//     "tb_trade_id": "3370522503588145164",
//     "tk_adzone_id": "114620150497",
//     "tk_pub_id": "2494480130",
//     "tk_site_id": "2607100136",
//     "tk_trade_create_time": "2023-05-30 20:07:26",
//     "violation_type": "订单虚假交易",
//     "sub_info": {
//       "pid": "2607100136_114620150497",
//       "sub_id": 15660,
//       "sub_remark": null,
//       "nickname": "a查券员6号置顶我哟陶宝查优慧券"
//     },
//     "tb_order_info": {
//       "id": 106547,
//       "sub_id": 15660,
//       "wxid": "wxid_w5y2vtiu4s6622",
//       "userid": 4765,
//       "fl_group": "0.01",
//       "fl_agent": "0.04",
//       "fl_second": "0.01",
//       "fl_user": "0.35",
//       "fl_Integral": null,
//       "flstatus": 1,
//       "luckdrawTAG": 0,
//       "luckdraw_time": "2023-05-31 15:40:46",
//       "relation_id": "",
//       "adzone_id": "114620150497",
//       "adzone_name": "6",
//       "alimama_rate": "10.00",
//       "alimama_share_fee": "0.04",
//       "alipay_total_price": "14.90",
//       "app_key": "24665425",
//       "click_time": "2023-05-29 19:27:41",
//       "deposit_price": "0.00",
//       "flow_source": "--",
//       "income_rate": "3.00",
//       "item_category_name": "美容护肤/美体/精油",
//       "pay_price": "14.90",
//       "item_id": "qYtrU8tDeYSWt0-dn2bKJ5TnMMJjoDPIP",
//       "item_img": "//img.alicdn.com/tfscom/i1/2215727205460/O1CN01CSDZUL1qCjMM34wUl_!!2215727205460-0-scmitem176000.jpg",
//       "item_link": "//uland.taobao.com/item/edetail?id=qYtrU8tDeYSWt0-dn2bKJ5TnMMJjoDPIP",
//       "item_num": 1,
//       "item_price": "22.35",
//       "item_title": "柳丝黑茶卸妆油膏水木女眼唇脸三合一温和深层清洁养肤官方正品",
//       "pub_id": "2494480130",
//       "pub_share_fee": "0.45",
//       "pub_share_pre_fee": "0.45",
//       "pub_share_rate": "100.00",
//       "refund_tag": 0,
//       "seller_nick": "天天特卖工厂店",
//       "seller_shop_title": "天天特卖工厂店",
//       "site_id": "2607100136",
//       "site_name": "爱分享(手机客户端专享)_2494480130",
//       "subsidy_fee": "0.00",
//       "subsidy_rate": "0.00",
//       "subsidy_type": "--",
//       "tb_deposit_time": "--",
//       "tb_paid_time": "2023-05-30 20:07:24",
//       "terminal_type": "无线",
//       "tk_commission_fee_for_media_platform": "0.00",
//       "tk_commission_pre_fee_for_media_platform": "0.00",
//       "tk_commission_rate_for_media_platform": "0.00",
//       "tk_create_time": "2023-05-30 20:07:26",
//       "tk_earning_time": "2023-05-31 15:39:43",
//       "tk_deposit_time": "--",
//       "tk_order_role": 2,
//       "tk_paid_time": "2023-05-30 20:07:39",
//       "tk_status": 3,
//       "tk_total_rate": "3.00",
//       "total_commission_fee": "0.45",
//       "total_commission_rate": "3.00",
//       "trade_id": "3370522503588145164",
//       "trade_parent_id": "3370522503585145164",
//       "tb_user_id": "",
//       "op_status": 0,
//       "binding_miss_remark": "尾号(145164)追单:用户WXID[qq174795826]，查券记录追单：2条，[wxid_9yyd5nf2rn7c22|wxid_w5y2vtiu4s6622|]",
//       "extra_type": 0,
//       "create_time": "2023-05-30 20:08:14",
//       "update_time": "2023-06-07 15:30:48",
//       "luckdrawTIME": null,
//       "user_info": {
//         "uid": 4765,
//         "sub_id": 15660,
//         "wxid": "wxid_w5y2vtiu4s6622",
//         "nickname": "壵壵熊",
//         "username": "bbifjjddr",
//         "usertype": 15,
//         "integral": 0,
//         "qdcount": 0,
//         "sign_amount": "0.00",
//         "qdlastdt": "",
//         "mmpid": "",
//         "pidname": "",
//         "trjid": "4281",
//         "groupid": "0",
//         "groupwxid": "",
//         "groupname": "",
//         "balance": "0.60",
//         "alipayrealname": "",
//         "alipaynum": "",
//         "regtime": "2023-04-13 14:16:53",
//         "order_sixbit": "220564",
//         "jdpid": "",
//         "pddpid": "",
//         "pdd_order_lastbit": "",
//         "order_num": 2473,
//         "smkey": 0,
//         "del": "0",
//         "order_date": "2023-06-28",
//         "jinjie1": "1",
//         "jinjie2": "1",
//         "jinjie3": "0",
//         "first_award": "1",
//         "remark": "",
//         "region": "",
//         "Evaluate_num": 0,
//         "avatar": "http://wx.qlogo.cn/mmhead/ver_1/icATFjlbKx1ZeQajHwz391C25JycORqdjUGicjZyvVrQ4bnchGWFPvkSQqugM3HY0cCpRTPAiaAVsgicQSBcmsPFrz4CUBVRFUNq0L1953y5X1o/0",
//         "openid": "",
//         "province": "",
//         "mark": "A2023-06-28单2473推13提688.06D4765壵壵熊",
//         "customer_remark": "",
//         "sex": 0,
//         "address": "",
//         "tag": null,
//         "invite_code": null,
//         "withdraw_amount": "688.06",
//         "finished_amount": "620.40",
//         "pay_amount": "28.84",
//         "useless_amount": null,
//         "finished_orders_number": 2319,
//         "pay_orders_number": 154,
//         "useless_orders_number": 0,
//         "sub_withdraw": "79.93",
//         "update_time": "2023-06-28 16:07:35",
//         "tb_user_id": ""
//       }
//     }
//   },
//   {
//     "punish_status": "0",
//     "settle_month": "202305",
//     "tb_trade_id": "3370522503587145164",
//     "tk_adzone_id": "114620150497",
//     "tk_pub_id": "2494480130",
//     "tk_site_id": "2607100136",
//     "tk_trade_create_time": "2023-05-30 20:07:26",
//     "violation_type": "订单虚假交易",
//     "sub_info": {
//       "pid": "2607100136_114620150497",
//       "sub_id": 15660,
//       "sub_remark": null,
//       "nickname": "a查券员6号置顶我哟陶宝查优慧券"
//     },
//     "tb_order_info": {
//       "id": 106548,
//       "sub_id": 15660,
//       "wxid": "wxid_w5y2vtiu4s6622",
//       "userid": 4765,
//       "fl_group": "0.01",
//       "fl_agent": "0.03",
//       "fl_second": "0.01",
//       "fl_user": "0.31",
//       "fl_Integral": null,
//       "flstatus": 1,
//       "luckdrawTAG": 0,
//       "luckdraw_time": "2023-05-31 15:40:57",
//       "relation_id": "",
//       "adzone_id": "114620150497",
//       "adzone_name": "6",
//       "alimama_rate": "10.00",
//       "alimama_share_fee": "0.04",
//       "alipay_total_price": "12.90",
//       "app_key": "24665425",
//       "click_time": "2023-05-29 19:27:41",
//       "deposit_price": "0.00",
//       "flow_source": "--",
//       "income_rate": "3.00",
//       "item_category_name": "美容护肤/美体/精油",
//       "pay_price": "12.90",
//       "item_id": "K5twUvtOkwTJtW-P8yrmq4uKyV9GG0KcGO",
//       "item_img": "//img.alicdn.com/tfscom/i3/3937219703/O1CN01nwFDjj2LY1rsQR8LZ_!!3937219703.jpg",
//       "item_link": "//uland.taobao.com/item/edetail?id=K5twUvtOkwTJtW-P8yrmq4uKyV9GG0KcGO",
//       "item_num": 1,
//       "item_price": "19.35",
//       "item_title": "黄芪霜祛黄老牌国货面霜去改善黄皮肤美氏变嫩白护肤滋润保湿补水",
//       "pub_id": "2494480130",
//       "pub_share_fee": "0.39",
//       "pub_share_pre_fee": "0.39",
//       "pub_share_rate": "100.00",
//       "refund_tag": 0,
//       "seller_nick": "天天特卖工厂店",
//       "seller_shop_title": "天天特卖工厂店",
//       "site_id": "2607100136",
//       "site_name": "爱分享(手机客户端专享)_2494480130",
//       "subsidy_fee": "0.00",
//       "subsidy_rate": "0.00",
//       "subsidy_type": "--",
//       "tb_deposit_time": "--",
//       "tb_paid_time": "2023-05-30 20:07:24",
//       "terminal_type": "无线",
//       "tk_commission_fee_for_media_platform": "0.00",
//       "tk_commission_pre_fee_for_media_platform": "0.00",
//       "tk_commission_rate_for_media_platform": "0.00",
//       "tk_create_time": "2023-05-30 20:07:26",
//       "tk_earning_time": "2023-05-31 15:39:42",
//       "tk_deposit_time": "--",
//       "tk_order_role": 2,
//       "tk_paid_time": "2023-05-30 20:07:39",
//       "tk_status": 3,
//       "tk_total_rate": "3.00",
//       "total_commission_fee": "0.39",
//       "total_commission_rate": "3.00",
//       "trade_id": "3370522503587145164",
//       "trade_parent_id": "3370522503585145164",
//       "tb_user_id": "",
//       "op_status": 0,
//       "binding_miss_remark": "尾号(145164)追单:用户WXID[qq174795826]，查券记录追单：2条，[wxid_9yyd5nf2rn7c22|wxid_w5y2vtiu4s6622|]",
//       "extra_type": 0,
//       "create_time": "2023-05-30 20:08:14",
//       "update_time": "2023-06-07 15:30:50",
//       "luckdrawTIME": null,
//       "user_info": {
//         "uid": 4765,
//         "sub_id": 15660,
//         "wxid": "wxid_w5y2vtiu4s6622",
//         "nickname": "壵壵熊",
//         "username": "bbifjjddr",
//         "usertype": 15,
//         "integral": 0,
//         "qdcount": 0,
//         "sign_amount": "0.00",
//         "qdlastdt": "",
//         "mmpid": "",
//         "pidname": "",
//         "trjid": "4281",
//         "groupid": "0",
//         "groupwxid": "",
//         "groupname": "",
//         "balance": "0.60",
//         "alipayrealname": "",
//         "alipaynum": "",
//         "regtime": "2023-04-13 14:16:53",
//         "order_sixbit": "220564",
//         "jdpid": "",
//         "pddpid": "",
//         "pdd_order_lastbit": "",
//         "order_num": 2473,
//         "smkey": 0,
//         "del": "0",
//         "order_date": "2023-06-28",
//         "jinjie1": "1",
//         "jinjie2": "1",
//         "jinjie3": "0",
//         "first_award": "1",
//         "remark": "",
//         "region": "",
//         "Evaluate_num": 0,
//         "avatar": "http://wx.qlogo.cn/mmhead/ver_1/icATFjlbKx1ZeQajHwz391C25JycORqdjUGicjZyvVrQ4bnchGWFPvkSQqugM3HY0cCpRTPAiaAVsgicQSBcmsPFrz4CUBVRFUNq0L1953y5X1o/0",
//         "openid": "",
//         "province": "",
//         "mark": "A2023-06-28单2473推13提688.06D4765壵壵熊",
//         "customer_remark": "",
//         "sex": 0,
//         "address": "",
//         "tag": null,
//         "invite_code": null,
//         "withdraw_amount": "688.06",
//         "finished_amount": "620.40",
//         "pay_amount": "28.84",
//         "useless_amount": null,
//         "finished_orders_number": 2319,
//         "pay_orders_number": 154,
//         "useless_orders_number": 0,
//         "sub_withdraw": "79.93",
//         "update_time": "2023-06-28 16:07:35",
//         "tb_user_id": ""
//       }
//     }
//   },
//   {
//     "punish_status": "0",
//     "settle_month": "202305",
//     "tb_trade_id": "1899645385728214582",
//     "tk_adzone_id": "114620150497",
//     "tk_pub_id": "2494480130",
//     "tk_site_id": "2607100136",
//     "tk_trade_create_time": "2023-05-30 20:05:24",
//     "violation_type": "订单虚假交易",
//     "sub_info": {
//       "pid": "2607100136_114620150497",
//       "sub_id": 15660,
//       "sub_remark": null,
//       "nickname": "a查券员6号置顶我哟陶宝查优慧券"
//     },
//     "tb_order_info": {
//       "id": 106546,
//       "sub_id": 15660,
//       "wxid": "wxid_w5y2vtiu4s6622",
//       "userid": 4765,
//       "fl_group": "0.01",
//       "fl_agent": "0.03",
//       "fl_second": "0.01",
//       "fl_user": "0.33",
//       "fl_Integral": null,
//       "flstatus": 1,
//       "luckdrawTAG": 0,
//       "luckdraw_time": "2023-05-31 15:54:15",
//       "relation_id": "",
//       "adzone_id": "114620150497",
//       "adzone_name": "6",
//       "alimama_rate": "10.00",
//       "alimama_share_fee": "0.04",
//       "alipay_total_price": "13.90",
//       "app_key": "24665425",
//       "click_time": "2023-05-29 19:34:49",
//       "deposit_price": "0.00",
//       "flow_source": "--",
//       "income_rate": "3.00",
//       "item_category_name": "彩妆/香水/美妆工具",
//       "pay_price": "13.90",
//       "item_id": "XrtpUgt0ZqtBtg-p6q9AoRfRAAkK7wdtj6",
//       "item_img": "//img.alicdn.com/tfscom/i1/3937219703/O1CN01ohJDGs2LY1rwvD5bt_!!3937219703.jpg",
//       "item_link": "//uland.taobao.com/item/edetail?id=XrtpUgt0ZqtBtg-p6q9AoRfRAAkK7wdtj6",
//       "item_num": 1,
//       "item_price": "20.85",
//       "item_title": "三色遮瑕膏盘官方旗舰遮盖眼袋脸部黑眼圈痘印斑点正品店",
//       "pub_id": "2494480130",
//       "pub_share_fee": "0.42",
//       "pub_share_pre_fee": "0.42",
//       "pub_share_rate": "100.00",
//       "refund_tag": 0,
//       "seller_nick": "天天特卖工厂店",
//       "seller_shop_title": "天天特卖工厂店",
//       "site_id": "2607100136",
//       "site_name": "爱分享(手机客户端专享)_2494480130",
//       "subsidy_fee": "0.00",
//       "subsidy_rate": "0.00",
//       "subsidy_type": "--",
//       "tb_deposit_time": "--",
//       "tb_paid_time": "2023-05-30 20:05:21",
//       "terminal_type": "无线",
//       "tk_commission_fee_for_media_platform": "0.00",
//       "tk_commission_pre_fee_for_media_platform": "0.00",
//       "tk_commission_rate_for_media_platform": "0.00",
//       "tk_create_time": "2023-05-30 20:05:24",
//       "tk_earning_time": "2023-05-31 15:49:04",
//       "tk_deposit_time": "--",
//       "tk_order_role": 2,
//       "tk_paid_time": "2023-05-30 20:05:36",
//       "tk_status": 3,
//       "tk_total_rate": "3.00",
//       "total_commission_fee": "0.42",
//       "total_commission_rate": "3.00",
//       "trade_id": "1899645385728214582",
//       "trade_parent_id": "1899645385727214582",
//       "tb_user_id": "",
//       "op_status": 0,
//       "binding_miss_remark": "尾号(214582)追单:不存在对应用户，查券记录2条，查券用户：wxid_9yyd5nf2rn7c22|wxid_w5y2vtiu4s6622|",
//       "extra_type": 0,
//       "create_time": "2023-05-30 20:06:12",
//       "update_time": "2023-06-07 15:30:39",
//       "luckdrawTIME": null,
//       "user_info": {
//         "uid": 4765,
//         "sub_id": 15660,
//         "wxid": "wxid_w5y2vtiu4s6622",
//         "nickname": "壵壵熊",
//         "username": "bbifjjddr",
//         "usertype": 15,
//         "integral": 0,
//         "qdcount": 0,
//         "sign_amount": "0.00",
//         "qdlastdt": "",
//         "mmpid": "",
//         "pidname": "",
//         "trjid": "4281",
//         "groupid": "0",
//         "groupwxid": "",
//         "groupname": "",
//         "balance": "0.60",
//         "alipayrealname": "",
//         "alipaynum": "",
//         "regtime": "2023-04-13 14:16:53",
//         "order_sixbit": "220564",
//         "jdpid": "",
//         "pddpid": "",
//         "pdd_order_lastbit": "",
//         "order_num": 2473,
//         "smkey": 0,
//         "del": "0",
//         "order_date": "2023-06-28",
//         "jinjie1": "1",
//         "jinjie2": "1",
//         "jinjie3": "0",
//         "first_award": "1",
//         "remark": "",
//         "region": "",
//         "Evaluate_num": 0,
//         "avatar": "http://wx.qlogo.cn/mmhead/ver_1/icATFjlbKx1ZeQajHwz391C25JycORqdjUGicjZyvVrQ4bnchGWFPvkSQqugM3HY0cCpRTPAiaAVsgicQSBcmsPFrz4CUBVRFUNq0L1953y5X1o/0",
//         "openid": "",
//         "province": "",
//         "mark": "A2023-06-28单2473推13提688.06D4765壵壵熊",
//         "customer_remark": "",
//         "sex": 0,
//         "address": "",
//         "tag": null,
//         "invite_code": null,
//         "withdraw_amount": "688.06",
//         "finished_amount": "620.40",
//         "pay_amount": "28.84",
//         "useless_amount": null,
//         "finished_orders_number": 2319,
//         "pay_orders_number": 154,
//         "useless_orders_number": 0,
//         "sub_withdraw": "79.93",
//         "update_time": "2023-06-28 16:07:35",
//         "tb_user_id": ""
//       }
//     }
//   },
//   {
//     "punish_status": "0",
//     "settle_month": "202305",
//     "tb_trade_id": "1899645385730214582",
//     "tk_adzone_id": "114620150497",
//     "tk_pub_id": "2494480130",
//     "tk_site_id": "2607100136",
//     "tk_trade_create_time": "2023-05-30 20:05:24",
//     "violation_type": "订单虚假交易",
//     "sub_info": {
//       "pid": "2607100136_114620150497",
//       "sub_id": 15660,
//       "sub_remark": null,
//       "nickname": "a查券员6号置顶我哟陶宝查优慧券"
//     },
//     "tb_order_info": {
//       "id": 106544,
//       "sub_id": 15660,
//       "wxid": "wxid_w5y2vtiu4s6622",
//       "userid": 4765,
//       "fl_group": "0.01",
//       "fl_agent": "0.03",
//       "fl_second": "0.01",
//       "fl_user": "0.31",
//       "fl_Integral": null,
//       "flstatus": 1,
//       "luckdrawTAG": 0,
//       "luckdraw_time": "2023-05-31 15:53:08",
//       "relation_id": "",
//       "adzone_id": "114620150497",
//       "adzone_name": "6",
//       "alimama_rate": "10.00",
//       "alimama_share_fee": "0.04",
//       "alipay_total_price": "12.90",
//       "app_key": "24665425",
//       "click_time": "2023-05-29 19:34:49",
//       "deposit_price": "0.00",
//       "flow_source": "--",
//       "income_rate": "3.00",
//       "item_category_name": "美容护肤/美体/精油",
//       "pay_price": "12.90",
//       "item_id": "K5twUvtOkwTJtW-P8yrmq4uKyV9GG0KcGO",
//       "item_img": "//img.alicdn.com/tfscom/i3/3937219703/O1CN01nwFDjj2LY1rsQR8LZ_!!3937219703.jpg",
//       "item_link": "//uland.taobao.com/item/edetail?id=K5twUvtOkwTJtW-P8yrmq4uKyV9GG0KcGO",
//       "item_num": 1,
//       "item_price": "19.35",
//       "item_title": "黄芪霜祛黄老牌国货面霜去改善黄皮肤美氏变嫩白护肤滋润保湿补水",
//       "pub_id": "2494480130",
//       "pub_share_fee": "0.39",
//       "pub_share_pre_fee": "0.39",
//       "pub_share_rate": "100.00",
//       "refund_tag": 0,
//       "seller_nick": "天天特卖工厂店",
//       "seller_shop_title": "天天特卖工厂店",
//       "site_id": "2607100136",
//       "site_name": "爱分享(手机客户端专享)_2494480130",
//       "subsidy_fee": "0.00",
//       "subsidy_rate": "0.00",
//       "subsidy_type": "--",
//       "tb_deposit_time": "--",
//       "tb_paid_time": "2023-05-30 20:05:21",
//       "terminal_type": "无线",
//       "tk_commission_fee_for_media_platform": "0.00",
//       "tk_commission_pre_fee_for_media_platform": "0.00",
//       "tk_commission_rate_for_media_platform": "0.00",
//       "tk_create_time": "2023-05-30 20:05:24",
//       "tk_earning_time": "2023-05-31 15:49:04",
//       "tk_deposit_time": "--",
//       "tk_order_role": 2,
//       "tk_paid_time": "2023-05-30 20:05:36",
//       "tk_status": 3,
//       "tk_total_rate": "3.00",
//       "total_commission_fee": "0.39",
//       "total_commission_rate": "3.00",
//       "trade_id": "1899645385730214582",
//       "trade_parent_id": "1899645385727214582",
//       "tb_user_id": "",
//       "op_status": 0,
//       "binding_miss_remark": "尾号(214582)追单:不存在对应用户，查券记录2条，查券用户：wxid_9yyd5nf2rn7c22|wxid_w5y2vtiu4s6622|",
//       "extra_type": 0,
//       "create_time": "2023-05-30 20:06:12",
//       "update_time": "2023-06-07 15:30:41",
//       "luckdrawTIME": null,
//       "user_info": {
//         "uid": 4765,
//         "sub_id": 15660,
//         "wxid": "wxid_w5y2vtiu4s6622",
//         "nickname": "壵壵熊",
//         "username": "bbifjjddr",
//         "usertype": 15,
//         "integral": 0,
//         "qdcount": 0,
//         "sign_amount": "0.00",
//         "qdlastdt": "",
//         "mmpid": "",
//         "pidname": "",
//         "trjid": "4281",
//         "groupid": "0",
//         "groupwxid": "",
//         "groupname": "",
//         "balance": "0.60",
//         "alipayrealname": "",
//         "alipaynum": "",
//         "regtime": "2023-04-13 14:16:53",
//         "order_sixbit": "220564",
//         "jdpid": "",
//         "pddpid": "",
//         "pdd_order_lastbit": "",
//         "order_num": 2473,
//         "smkey": 0,
//         "del": "0",
//         "order_date": "2023-06-28",
//         "jinjie1": "1",
//         "jinjie2": "1",
//         "jinjie3": "0",
//         "first_award": "1",
//         "remark": "",
//         "region": "",
//         "Evaluate_num": 0,
//         "avatar": "http://wx.qlogo.cn/mmhead/ver_1/icATFjlbKx1ZeQajHwz391C25JycORqdjUGicjZyvVrQ4bnchGWFPvkSQqugM3HY0cCpRTPAiaAVsgicQSBcmsPFrz4CUBVRFUNq0L1953y5X1o/0",
//         "openid": "",
//         "province": "",
//         "mark": "A2023-06-28单2473推13提688.06D4765壵壵熊",
//         "customer_remark": "",
//         "sex": 0,
//         "address": "",
//         "tag": null,
//         "invite_code": null,
//         "withdraw_amount": "688.06",
//         "finished_amount": "620.40",
//         "pay_amount": "28.84",
//         "useless_amount": null,
//         "finished_orders_number": 2319,
//         "pay_orders_number": 154,
//         "useless_orders_number": 0,
//         "sub_withdraw": "79.93",
//         "update_time": "2023-06-28 16:07:35",
//         "tb_user_id": ""
//       }
//     }
//   },
//   {
//     "punish_status": "0",
//     "settle_month": "202305",
//     "tb_trade_id": "1899645385729214582",
//     "tk_adzone_id": "114620150497",
//     "tk_pub_id": "2494480130",
//     "tk_site_id": "2607100136",
//     "tk_trade_create_time": "2023-05-30 20:05:24",
//     "violation_type": "订单虚假交易",
//     "sub_info": {
//       "pid": "2607100136_114620150497",
//       "sub_id": 15660,
//       "sub_remark": null,
//       "nickname": "a查券员6号置顶我哟陶宝查优慧券"
//     },
//     "tb_order_info": {
//       "id": 106545,
//       "sub_id": 15660,
//       "wxid": "wxid_w5y2vtiu4s6622",
//       "userid": 4765,
//       "fl_group": "0.01",
//       "fl_agent": "0.04",
//       "fl_second": "0.01",
//       "fl_user": "0.35",
//       "fl_Integral": null,
//       "flstatus": 1,
//       "luckdrawTAG": 0,
//       "luckdraw_time": "2023-05-31 15:54:04",
//       "relation_id": "",
//       "adzone_id": "114620150497",
//       "adzone_name": "6",
//       "alimama_rate": "10.00",
//       "alimama_share_fee": "0.04",
//       "alipay_total_price": "14.90",
//       "app_key": "24665425",
//       "click_time": "2023-05-29 19:34:49",
//       "deposit_price": "0.00",
//       "flow_source": "--",
//       "income_rate": "3.00",
//       "item_category_name": "美容护肤/美体/精油",
//       "pay_price": "14.90",
//       "item_id": "qYtrU8tDeYSWt0-dn2bKJ5TnMMJjoDPIP",
//       "item_img": "//img.alicdn.com/tfscom/i1/2215727205460/O1CN01CSDZUL1qCjMM34wUl_!!2215727205460-0-scmitem176000.jpg",
//       "item_link": "//uland.taobao.com/item/edetail?id=qYtrU8tDeYSWt0-dn2bKJ5TnMMJjoDPIP",
//       "item_num": 1,
//       "item_price": "22.35",
//       "item_title": "柳丝黑茶卸妆油膏水木女眼唇脸三合一温和深层清洁养肤官方正品",
//       "pub_id": "2494480130",
//       "pub_share_fee": "0.45",
//       "pub_share_pre_fee": "0.45",
//       "pub_share_rate": "100.00",
//       "refund_tag": 0,
//       "seller_nick": "天天特卖工厂店",
//       "seller_shop_title": "天天特卖工厂店",
//       "site_id": "2607100136",
//       "site_name": "爱分享(手机客户端专享)_2494480130",
//       "subsidy_fee": "0.00",
//       "subsidy_rate": "0.00",
//       "subsidy_type": "--",
//       "tb_deposit_time": "--",
//       "tb_paid_time": "2023-05-30 20:05:21",
//       "terminal_type": "无线",
//       "tk_commission_fee_for_media_platform": "0.00",
//       "tk_commission_pre_fee_for_media_platform": "0.00",
//       "tk_commission_rate_for_media_platform": "0.00",
//       "tk_create_time": "2023-05-30 20:05:24",
//       "tk_earning_time": "2023-05-31 15:49:04",
//       "tk_deposit_time": "--",
//       "tk_order_role": 2,
//       "tk_paid_time": "2023-05-30 20:05:36",
//       "tk_status": 3,
//       "tk_total_rate": "3.00",
//       "total_commission_fee": "0.45",
//       "total_commission_rate": "3.00",
//       "trade_id": "1899645385729214582",
//       "trade_parent_id": "1899645385727214582",
//       "tb_user_id": "",
//       "op_status": 0,
//       "binding_miss_remark": "尾号(214582)追单:不存在对应用户，查券记录2条，查券用户：wxid_9yyd5nf2rn7c22|wxid_w5y2vtiu4s6622|",
//       "extra_type": 0,
//       "create_time": "2023-05-30 20:06:12",
//       "update_time": "2023-06-07 15:30:43",
//       "luckdrawTIME": null,
//       "user_info": {
//         "uid": 4765,
//         "sub_id": 15660,
//         "wxid": "wxid_w5y2vtiu4s6622",
//         "nickname": "壵壵熊",
//         "username": "bbifjjddr",
//         "usertype": 15,
//         "integral": 0,
//         "qdcount": 0,
//         "sign_amount": "0.00",
//         "qdlastdt": "",
//         "mmpid": "",
//         "pidname": "",
//         "trjid": "4281",
//         "groupid": "0",
//         "groupwxid": "",
//         "groupname": "",
//         "balance": "0.60",
//         "alipayrealname": "",
//         "alipaynum": "",
//         "regtime": "2023-04-13 14:16:53",
//         "order_sixbit": "220564",
//         "jdpid": "",
//         "pddpid": "",
//         "pdd_order_lastbit": "",
//         "order_num": 2473,
//         "smkey": 0,
//         "del": "0",
//         "order_date": "2023-06-28",
//         "jinjie1": "1",
//         "jinjie2": "1",
//         "jinjie3": "0",
//         "first_award": "1",
//         "remark": "",
//         "region": "",
//         "Evaluate_num": 0,
//         "avatar": "http://wx.qlogo.cn/mmhead/ver_1/icATFjlbKx1ZeQajHwz391C25JycORqdjUGicjZyvVrQ4bnchGWFPvkSQqugM3HY0cCpRTPAiaAVsgicQSBcmsPFrz4CUBVRFUNq0L1953y5X1o/0",
//         "openid": "",
//         "province": "",
//         "mark": "A2023-06-28单2473推13提688.06D4765壵壵熊",
//         "customer_remark": "",
//         "sex": 0,
//         "address": "",
//         "tag": null,
//         "invite_code": null,
//         "withdraw_amount": "688.06",
//         "finished_amount": "620.40",
//         "pay_amount": "28.84",
//         "useless_amount": null,
//         "finished_orders_number": 2319,
//         "pay_orders_number": 154,
//         "useless_orders_number": 0,
//         "sub_withdraw": "79.93",
//         "update_time": "2023-06-28 16:07:35",
//         "tb_user_id": ""
//       }
//     }
//   },
//   {
//     "punish_status": "0",
//     "settle_month": "202305",
//     "tb_trade_id": "1899576662262964199",
//     "tk_adzone_id": "114620150497",
//     "tk_pub_id": "2494480130",
//     "tk_site_id": "2607100136",
//     "tk_trade_create_time": "2023-05-30 20:03:53",
//     "violation_type": "订单虚假交易",
//     "sub_info": {
//       "pid": "2607100136_114620150497",
//       "sub_id": 15660,
//       "sub_remark": null,
//       "nickname": "a查券员6号置顶我哟陶宝查优慧券"
//     },
//     "tb_order_info": {
//       "id": 106541,
//       "sub_id": 15660,
//       "wxid": "wxid_w5y2vtiu4s6622",
//       "userid": 4765,
//       "fl_group": "0.01",
//       "fl_agent": "0.04",
//       "fl_second": "0.01",
//       "fl_user": "0.35",
//       "fl_Integral": null,
//       "flstatus": 1,
//       "luckdrawTAG": 0,
//       "luckdraw_time": "2023-05-31 15:49:40",
//       "relation_id": "",
//       "adzone_id": "114620150497",
//       "adzone_name": "6",
//       "alimama_rate": "10.00",
//       "alimama_share_fee": "0.04",
//       "alipay_total_price": "14.90",
//       "app_key": "24665425",
//       "click_time": "2023-05-29 19:40:24",
//       "deposit_price": "0.00",
//       "flow_source": "--",
//       "income_rate": "3.00",
//       "item_category_name": "美容护肤/美体/精油",
//       "pay_price": "14.90",
//       "item_id": "qYtrU8tDeYSWt0-dn2bKJ5TnMMJjoDPIP",
//       "item_img": "//img.alicdn.com/tfscom/i1/2215727205460/O1CN01CSDZUL1qCjMM34wUl_!!2215727205460-0-scmitem176000.jpg",
//       "item_link": "//uland.taobao.com/item/edetail?id=qYtrU8tDeYSWt0-dn2bKJ5TnMMJjoDPIP",
//       "item_num": 1,
//       "item_price": "22.35",
//       "item_title": "柳丝黑茶卸妆油膏水木女眼唇脸三合一温和深层清洁养肤官方正品",
//       "pub_id": "2494480130",
//       "pub_share_fee": "0.45",
//       "pub_share_pre_fee": "0.45",
//       "pub_share_rate": "100.00",
//       "refund_tag": 0,
//       "seller_nick": "天天特卖工厂店",
//       "seller_shop_title": "天天特卖工厂店",
//       "site_id": "2607100136",
//       "site_name": "爱分享(手机客户端专享)_2494480130",
//       "subsidy_fee": "0.00",
//       "subsidy_rate": "0.00",
//       "subsidy_type": "--",
//       "tb_deposit_time": "--",
//       "tb_paid_time": "2023-05-30 20:03:50",
//       "terminal_type": "无线",
//       "tk_commission_fee_for_media_platform": "0.00",
//       "tk_commission_pre_fee_for_media_platform": "0.00",
//       "tk_commission_rate_for_media_platform": "0.00",
//       "tk_create_time": "2023-05-30 20:03:53",
//       "tk_earning_time": "2023-05-31 15:48:11",
//       "tk_deposit_time": "--",
//       "tk_order_role": 2,
//       "tk_paid_time": "2023-05-30 20:04:05",
//       "tk_status": 3,
//       "tk_total_rate": "3.00",
//       "total_commission_fee": "0.45",
//       "total_commission_rate": "3.00",
//       "trade_id": "1899576662262964199",
//       "trade_parent_id": "1899576662259964199",
//       "tb_user_id": "",
//       "op_status": 0,
//       "binding_miss_remark": "尾号(964199)追单:不存在对应用户，查券记录2条，查券用户：wxid_9yyd5nf2rn7c22|wxid_w5y2vtiu4s6622|",
//       "extra_type": 0,
//       "create_time": "2023-05-30 20:05:11",
//       "update_time": "2023-06-07 15:30:34",
//       "luckdrawTIME": null,
//       "user_info": {
//         "uid": 4765,
//         "sub_id": 15660,
//         "wxid": "wxid_w5y2vtiu4s6622",
//         "nickname": "壵壵熊",
//         "username": "bbifjjddr",
//         "usertype": 15,
//         "integral": 0,
//         "qdcount": 0,
//         "sign_amount": "0.00",
//         "qdlastdt": "",
//         "mmpid": "",
//         "pidname": "",
//         "trjid": "4281",
//         "groupid": "0",
//         "groupwxid": "",
//         "groupname": "",
//         "balance": "0.60",
//         "alipayrealname": "",
//         "alipaynum": "",
//         "regtime": "2023-04-13 14:16:53",
//         "order_sixbit": "220564",
//         "jdpid": "",
//         "pddpid": "",
//         "pdd_order_lastbit": "",
//         "order_num": 2473,
//         "smkey": 0,
//         "del": "0",
//         "order_date": "2023-06-28",
//         "jinjie1": "1",
//         "jinjie2": "1",
//         "jinjie3": "0",
//         "first_award": "1",
//         "remark": "",
//         "region": "",
//         "Evaluate_num": 0,
//         "avatar": "http://wx.qlogo.cn/mmhead/ver_1/icATFjlbKx1ZeQajHwz391C25JycORqdjUGicjZyvVrQ4bnchGWFPvkSQqugM3HY0cCpRTPAiaAVsgicQSBcmsPFrz4CUBVRFUNq0L1953y5X1o/0",
//         "openid": "",
//         "province": "",
//         "mark": "A2023-06-28单2473推13提688.06D4765壵壵熊",
//         "customer_remark": "",
//         "sex": 0,
//         "address": "",
//         "tag": null,
//         "invite_code": null,
//         "withdraw_amount": "688.06",
//         "finished_amount": "620.40",
//         "pay_amount": "28.84",
//         "useless_amount": null,
//         "finished_orders_number": 2319,
//         "pay_orders_number": 154,
//         "useless_orders_number": 0,
//         "sub_withdraw": "79.93",
//         "update_time": "2023-06-28 16:07:35",
//         "tb_user_id": ""
//       }
//     }
//   }
// ]
          this.pagein.total = Number(res.data.count)
          this.pagein.current = Number(res.data.page)
          this.$message.success('获取成功')
          this.loading = false
        } else {
          this.$message.error(res.msg)
          this.loading = false
          // this.handleCancel()
        }
      })
    },

    // 翻页
    tableChange(obj) {
      // console.log('obj=', obj)
      this.pagein.current = obj.current
      this.pagein.pageSize = obj.pageSize
      this.irregularOrders()
    },

    // 选中某些行时
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      // console.log('this.selectedRows=', this.selectedRows)
      // console.log('this.selectedRowKeys=', this.selectedRowKeys)
    },

    // 扣除返利
    deductionRebate(){
      this.$refs.sendMsgModal.show(this.selectedRows)
      // console.log('扣除返利')
    },

    // 上传用户到黑名单
    async uploadBlacklist() {
      let tempArr = this.selectedRows
      console.log('tempArr=', tempArr)
      tempArr = [
        { tb_order_info: { wxid: 'wxid_pp0tgclxrocv12', user_info: { regtime: '2023-05-24 15:49:48', nickname: '一', avatar: 'http://wx.qlogo.cn/mmhead/ver_1/duAJia5ZyC0tEggQcaiahSHa0UUD0eGiaDfFo36B829KXoRZCyjicMch9EDdYjibSRRol4p7gAibbId5icvqNa6UvjEgGC1lxpXhPZ19pHFbjIBdDc/0' }}, sub_info: { sub_id: '31974' } },
        { tb_order_info: { wxid: 'wxid_1t5f433yc4kn22', user_info: { regtime: '2023-05-24 15:49:48', nickname: '二', avatar: 'http://wx.qlogo.cn/mmhead/ver_1/duAJia5ZyC0tEggQcaiahSHa0UUD0eGiaDfFo36B829KXoRZCyjicMch9EDdYjibSRRol4p7gAibbId5icvqNa6UvjEgGC1lxpXhPZ19pHFbjIBdDc/0' }}, sub_info: { sub_id: '31974' } },
        { tb_order_info: { wxid: 'wxid_bjhuxw9wwr0j22', user_info: { regtime: '2023-05-24 15:49:48', nickname: '三', avatar: 'http://wx.qlogo.cn/mmhead/ver_1/duAJia5ZyC0tEggQcaiahSHa0UUD0eGiaDfFo36B829KXoRZCyjicMch9EDdYjibSRRol4p7gAibbId5icvqNa6UvjEgGC1lxpXhPZ19pHFbjIBdDc/0' }}, sub_info: {sub_id: '31974'} },
        { tb_order_info: { wxid: 'wxid123456789', user_info: { regtime: '2023-05-24 15:49:48', nickname: '三', avatar: 'http://wx.qlogo.cn/mmhead/ver_1/duAJia5ZyC0tEggQcaiahSHa0UUD0eGiaDfFo36B829KXoRZCyjicMch9EDdYjibSRRol4p7gAibbId5icvqNa6UvjEgGC1lxpXhPZ19pHFbjIBdDc/0' }}, sub_info: {sub_id: '31974'} }
      ]
      let promises = []
      let failedWxIds = []
      
      for (let i = 0; i < tempArr.length; i++) {
        let userDetail = {
          avatar: tempArr[i].tb_order_info.user_info.avatar,
          nickname: tempArr[i].tb_order_info.user_info.nickname,
          regtime: tempArr[i].tb_order_info.user_info.regtime
        }
        let promise = new Promise((resolve, reject) => {
          setTimeout(() => {
            FansApi.addBlackList({
              sub_id: tempArr[i].sub_info.sub_id,
              wx_id: tempArr[i].tb_order_info.wxid,
              type: 6, // 加入黑名单的类型-6：其他
              snapshot: JSON.stringify(userDetail),
              remark: ''
            }).then(() => {
              resolve()
            }).catch(() => {
              failedWxIds.push(tempArr[i].tb_order_info.wxid)
              resolve()
            })
          }, i * 1000)
        })
        
        promises.push(promise)
      }
      
      try {
        await Promise.all(promises)
        if (failedWxIds.length === 0) {
          this.$message.success('全部成功')
        } else {
          this.$message.error(`部分失败，失败的wxid:${failedWxIds}`)
        }
      } catch (error) {
        this.$message.error(`出错了~，请您重新添加`)
      }
    }
    // uploadBlacklist(){
    //   let tempArr = this.selectedRows
    //   console.log('tempArr=', tempArr)
    //   for(let i=0; i< tempArr.length; i++){
    //     setTimeout(() => {
    //       FansApi.addBlackList({
    //         sub_id: tempArr[i].sub_info.sub_id,
    //         wx_id: tempArr[i].tb_order_info.wxid,
    //         type: 6, // 加入黑名单的类型-6：其他
    //         snapshot: '',
    //         remark: ''
    //       })
    //     }, i * 1000)
    //   }
    // },

  }
}
</script>

<style scoped lang="less">
.hiddenText {
  display: inline-block;
  width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

// 选择框圆角
.selectClass /deep/ .ant-select-selection--single {
  /* color: red; */
  border-radius: 7px;
}
</style>